import React, { Component, Fragment } from "react";
import { Collapse, Select, TreeSelect } from "antd";

const { SHOW_PARENT } = TreeSelect;

const ENABLE_OPTIONS = [{
  key: "traceCapacitance",
  title: "Total Trace Capacitance"
},
{
  key: "endToEnd",
  title: "End to End"
},
{
  key: "impedance",
  title: "Impedance"
},
{
  key: "delay",
  title: "Delay"
},
{
  key: "sParameter",
  title: "Network Parameter"
}];
const EXCLUDED_OPTIONS = [{
  key: "waveform",
  value: "waveform",
  title: "Waveform",
  children: [{
    key: "waveform::usage::Driver",
    value: "waveform::usage::Driver",
    title: "Driver",
    display: "Waveform - Driver"
  },
  {
    key: "waveform::usage::Receiver",
    value: "waveform::usage::Receiver",
    title: "Receiver",
    display: "Waveform - Receiver"
  },
  {
    key: "waveform::usage::Connector",
    value: "waveform::usage::Connector",
    title: "Connector",
    display: "Waveform - Connector"
  },
  {
    key: "waveform::usage::Repeater",
    value: "waveform::usage::Repeater",
    title: "Repeater",
    display: "Waveform - Repeater"
  },
  {
    key: "waveform::usage::testPoint",
    value: "waveform::usage::testPoint",
    title: "Test Point",
    display: "Waveform - Test Point"
  }]
}];
const Option = Select.Option;
class ReportAdvance extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  enableOptionsChange = (keys) => {
    const enableOptions = [...(keys || [])];
    this.props.changeAdvanceData(enableOptions, "enableOptions");
  }

  excludeOptionsChange = (keys) => {
    const values = [...(keys || [])];
    let _excludedOptions = {};
    for (let value of values) {
      const [resultType, type, key] = (value || "").split("::");
      if (!type || !key) {
        if (resultType) {
          if (!_excludedOptions[resultType]) {
            _excludedOptions[resultType] = []
          }
          const _values = ((EXCLUDED_OPTIONS.find(it => it.key === resultType) || {}).children || []).map(item => item.key);
          _excludedOptions[resultType].push(..._values.map(item => {
            const [_resultType, _type, _key] = (item || "").split("::");
            return {
              type: _type,
              key: _key
            }
          }))
        }
        continue;
      }

      if (!_excludedOptions[resultType]) {
        _excludedOptions[resultType] = []
      }
      _excludedOptions[resultType].push({
        type,
        key
      })
    }
    this.props.changeAdvanceData(_excludedOptions, "excludedOptions");
  }

  getExcludeValues = (excludedOptions) => {
    const keys = Object.keys(excludedOptions || {});
    let values = []
    for (let key of keys) {
      const list = excludedOptions[key] || [];
      values.push(...list.map(item => `${key}::${item.type}::${item.key}`))
    }
    return values;
  }

  render = () => {
    const { reportConfig = {} } = this.props;
    const { enableOptions = [], excludedOptions = {} } = reportConfig || {};
    const excludedValues = this.getExcludeValues(excludedOptions);
    const items = [
      {
        key: "advanced",
        label: <div className="sierra-report-advances-header">
          <span>Advanced</span>
        </div>,
        children: <Fragment>
          <div className="sierra-report-advances-enable-options">
            <span className="sierra-report-advances-enable-title">Optional Results</span>
            <Select
              mode="multiple"
              className="sierra-report-advances-enable-select"
              value={enableOptions || []}
              onChange={this.enableOptionsChange}
              popupMatchSelectWidth={false}
              allowClear={true}
              popupClassName="sierra-report-advances-enable-select-dropdown"
              options={ENABLE_OPTIONS.map(item => ({
                value: item.key,
                label: item.title
              }))}
            />
          </div>
          <div className="sierra-report-advances-enable-options sierra-report-advances-excluded-options">
            <span className="sierra-report-advances-enable-title">Excluded Results</span>
            <TreeSelect
              className="sierra-report-advances-enable-select"
              popupClassName="sierra-report-advances-enable-select-dropdown"
              treeData={EXCLUDED_OPTIONS}
              value={excludedValues}
              onChange={this.excludeOptionsChange}
              treeCheckable={true}
              showCheckedStrategy={SHOW_PARENT}
              placeholder={"Please Select"}
              treeDefaultExpandAll={true}
              treeNodeLabelProp="display"
            />
          </div>
        </Fragment>
      },
    ]
    return <Collapse className="sierra-report-advances-collapse" items={items} />;
  }
}
export default ReportAdvance